import { render, staticRenderFns } from "./RelatedOrderLink.vue?vue&type=template&id=7c9a3612"
import script from "./RelatedOrderLink.vue?vue&type=script&lang=js"
export * from "./RelatedOrderLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports